import Axios from "axios";
import { domain } from "../config/url";

export const axios = Axios.create({
  baseURL: domain,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

export const multiPartAxios = Axios.create({
  baseURL: domain,
  headers: {
    "Content-Type": "multipart/form-data",
  },
  withCredentials: true,
});
